module.exports = __webpack_public_path__ + "static/img/ts.888b2b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/ts.png
// module id = jh4U
// module chunks = 52